import * as t from "io-ts";

export const EmailVerificationStatus = t.keyof({
  Verified: true,
  WaitingForVerification: true,
  LinkExpired: true,
});
export type EmailVerificationStatus = t.TypeOf<typeof EmailVerificationStatus>;
